import privileges from './privileges.js'

var general = {
	convertToSlug: function (str) {
		str = str.trim()
		str = str.toLowerCase()

		// remove accents, swap ñ for n, etc
		const from = 'åàáãäâèéëêìíïîòóöôùúüûñç·/_,:;'
		const to = 'aaaaaaeeeeiiiioooouuuunc------'

		for (let i = 0, l = from.length; i < l; i++) {
			str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
		}

		return str
			.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
			.replace(/\s+/g, '-') // collapse whitespace and replace by -
			.replace(/-+/g, '-') // collapse dashes
			.replace(/^-+/, '') // trim - from start of text
			.replace(/-+$/, '') // trim - from end of text
			.replace(/-/g, '-')
	},

	returnUniqueSlug: function (name, slugsArr, int) {
		int++
		var slug = this.convertToSlug(name)
		var exists = slugsArr.indexOf(slug) > -1

		if (exists) {
			var regex = /-\d$/g
			var match = slug.match(regex)

			if (match) {
				slug = slug.replace(regex, '')
			}

			slug = slug + '-' + int
			slug = this.returnUniqueSlug(slug, slugsArr, int)
		}

		return slug
	},

	saveAnimation: function () {
		var el = document.getElementsByClassName('saveAnimation')

		el[0].classList.add('play')

		setTimeout(function () {
			el[0].classList.remove('play')
		}, 1000)
	},

	isJson: function (str) {
		try {
			JSON.parse(str)
		} catch (e) {
			return false
		}
		return true
	},

	getCookie: function (name) {
		var pattern = RegExp(name + '=.[^;]*')
		var matched = document.cookie.match(pattern)
		if (matched) {
			var cookie = matched[0].split('=')
			return cookie[1]
		}
		return false
	},

	findItemWithLowestPriority (items) {
		var lowestPriority = null
		var foundItem = null
		var amount = Object.keys(items).length
		var int = 0

		for (var item in items) {
			int++
			if (!lowestPriority) {
				lowestPriority = items[item].priority
				foundItem = items[item]
			} else {
				if (items[item].priority < lowestPriority) {
					lowestPriority = items[item].priority
					foundItem = items[item]
				}
			}

			if (int === amount) {
				return foundItem
			}
		}
	},

	checkPermissions: function (objectPrivileges, userRoles) {
		var privilegesArr = {
			'view': false,
			'add': false,
			'edit': false,
			'delete': false
		}

		// check for each role that the user has what he can or cannot do
		var amountUserRoles = Object.keys(userRoles).length
		var int = 0
		for (var role in userRoles) {
			int++
			if (role === 'Admin') {
				privilegesArr.view = true
				privilegesArr.add = true
				privilegesArr.edit = true
				privilegesArr.delete = true
			} else {
				if (objectPrivileges[role]) {
					var value = objectPrivileges[role].value
					if (!privilegesArr.view) privilegesArr.view = privileges.canAccess(value)
					if (!privilegesArr.add) privilegesArr.add = privileges.canCreate(value)
					if (!privilegesArr.edit) privilegesArr.edit = privileges.canUpdate(value)
					if (!privilegesArr.delete) privilegesArr.delete = privileges.canDelete(value)
				}
			}

			if (int === amountUserRoles) {
				return privilegesArr
			}
		}
	},

	convertFormDataToObject: function (formData) {
		var object = {}
		formData.forEach((value, key) => {
			// Reflect.has in favor of: object.hasOwnProperty(key)
			if (!Reflect.has(object, key)) {
				object[key] = value
				return
			}
			if (!Array.isArray(object[key])) {
				object[key] = [object[key]]
			}
			object[key].push(value)
		})
		return object
	},

	getMainSlug () {
		var pathName = window.location.pathname
		return pathName.split('/')[1]
	},

	removeAllClassesStartingWithPrefix: function (prefix, el) {
		const classes = el.className.split(' ').filter(c => !c.startsWith(prefix))
		el.className = classes.join(' ').trim()
	},

	numDaysBetween: function (d1, d2) {
		var today = d2.getTime() / 1000
		var diff = Math.abs(d1 - (today))

		var amountOfMinutesAgo = diff / (60)
		var amountOfHoursAgo = diff / (60 * 60)
		var amountOfDaysAgo = diff / (60 * 60 * 24)

		var result = null
		if (amountOfMinutesAgo < 60) {
			result = parseInt(amountOfMinutesAgo) + ' minute(s) ago'
		}

		if (amountOfMinutesAgo >= 60 && amountOfHoursAgo < 24) {
			result = parseInt(amountOfHoursAgo) + ' hour(s) ago'
		}

		if (amountOfHoursAgo >= 24) {
			result = parseInt(amountOfDaysAgo) + ' day(s) ago'
		}

		return result
	},

	childrenMatches: function (elem, selector) {
		// if the element does not exist we can just return an empty array
		if (!elem) return []

		// find the direct childs
		return Array.prototype.filter.call(elem.children, function (child) {
			return child.matches(selector)
		})
	},

	arrayMove: function (arr, oldIndex, newIndex) {
		if (newIndex >= arr.length) {
			var k = newIndex - arr.length + 1
			while (k--) {
				arr.push(undefined)
			}
		}
		arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0])
		return arr
	}
}

export default general
